import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { InsuranceVariantService } from './insurance-variant.service';

export type SlotsViewVariantCode = 'scroll' | 'cards';

// Reads the variant the app already assigns on startup (InsuranceVariantService / index.html);
// the active scroll/cards test is what the assign API hands out.
@Injectable({
  providedIn: 'root'
})
export class SlotsViewVariantService {
  constructor(private variants: InsuranceVariantService) {}

  // Never errors: any failure means the existing scroll view.
  resolveVariant(): Observable<SlotsViewVariantCode> {
    return this.variants.ensureAssignmentCached('available-slots').pipe(
      map((assignment) => (assignment?.version_code === 'cards' ? 'cards' : 'scroll') as SlotsViewVariantCode),
      catchError(() => of('scroll' as SlotsViewVariantCode))
    );
  }
}
